import React from 'react';
import QuestionSetsDetailPane from './QuestionSetsDetailPane';
import QuestionSetDetailPane from './QuestionSetDetailPane';

export function OverviewDetailPane(props) {
  return props.questionSetKey == null ? (
    <QuestionSetsDetailPane {...props} />
  ) : (
    <QuestionSetDetailPane {...props} />
  );
}

export default OverviewDetailPane;
